import type { XlsxTemplate } from '../../../../common/interfaces/xlsx-section';

export const CONTRACTORS_XLSX_TEMPLATE: XlsxTemplate = [
  {
    name: 'contractors.contractorForm.companyProfile.heading',
    fields: [
      {
        key: 'country',
        name: 'labels.country',
        required: true,
      },
      {
        key: 'vatId',
        name: 'labels.vatId',
        required: true,
      },
      {
        key: 'displayName',
        name: 'labels.displayName',
      },
      {
        key: 'companyName',
        name: 'labels.fullName',
      },
      {
        key: 'types',
        name: 'labels.businessType',
      },
      {
        key: 'phone',
        name: 'labels.officePhone',
      },
    ],
    required: true,
  },
  {
    name: 'labels.mainBranch',
    fields: [
      {
        key: 'mainAddress',
        name: 'labels.mainAddress',
        required: true,
      },
      {
        key: 'correspondenceAddress',
        name: 'labels.correspondenceAddress',
      },
    ],
    required: true,
  },
  {
    name: 'contractors.contractorForm.payment.heading',
    fields: [
      {
        key: 'termDays',
        name: (translateService) =>
          `${translateService.instant('labels.paymentTerm')} [${translateService.instant('labels.days').toLowerCase()}]`,
        required: true,
      },
      {
        key: 'termType',
        name: 'labels.termFrom',
        required: true,
      },
      {
        key: 'selectedTermDay',
        name: 'labels.dayOfMonth',
      },
      {
        key: 'tradeCreditLimitValue',
        name: 'labels.tradeCredit',
      },
      {
        key: 'tradeCreditLimitCurrency',
        name: (translateService) =>
          `${translateService.instant('labels.tradeCredit')} (${translateService.instant('labels.currency').toLowerCase()})`,
        required: true,
      },
      {
        key: 'cashDiscountPercentage',
        name: (translateService) =>
          `${translateService.instant('labels.cashDiscount')} [%]`,
      },
      {
        key: 'cashDiscountTermDays',
        name: (translateService) =>
          `${translateService.instant('labels.cashDiscount')} (${translateService.instant('labels.term').toLowerCase()}) [${translateService.instant('labels.days').toLowerCase()}]`,
      },
      {
        key: 'hasFactoringConsent',
        name: 'labels.factoringConsent',
      },
    ],
    required: true,
  },
  {
    name: 'contractors.contractorForm.invoiceDocuments.heading',
    fields: [
      {
        key: 'invoiceDocumentsEmails',
        name: 'labels.byEmail',
      },
      {
        key: 'invoiceDocumentsInternalPortalUrl',
        name: (translateService) =>
          `${translateService.instant('labels.internalPortal')} (${translateService.instant('labels.siteUrl').toLowerCase()})`,
      },
      {
        key: 'invoiceDocumentsInternalPortalLogin',
        name: (translateService) =>
          `${translateService.instant('labels.internalPortal')} (${translateService.instant('labels.login').toLowerCase()})`,
      },
      {
        key: 'invoiceDocumentsInternalPortalPassword',
        name: (translateService) =>
          `${translateService.instant('labels.internalPortal')} (${translateService.instant('labels.password').toLowerCase()})`,
      },
      {
        key: 'invoiceDocumentsTraditionalMail',
        name: 'labels.traditionalMail',
      },
      {
        key: 'invoiceDocumentsIsOriginalDocumentRequired',
        name: 'labels.originalDocumentRequired',
      },
    ],
  },
  {
    name: 'contractors.contractorForm.invoices.heading',
    fields: [
      {
        key: 'invoicesDefaultType',
        name: 'labels.defaultInvoiceType',
        required: true,
      },
      {
        key: 'invoicesCollectiveInvoiceIssueTerm',
        name: 'labels.invoicing',
      },
      {
        key: 'invoicesCollectiveInvoiceIssueSelectedDay',
        name: 'labels.dayOfMonth',
      },
      {
        key: 'invoicesEmails',
        name: 'labels.byEmail',
      },
      {
        key: 'invoicesInternalPortalUrl',
        name: (translateService) =>
          `${translateService.instant('labels.internalPortal')} (${translateService.instant('labels.siteUrl').toLowerCase()})`,
      },
      {
        key: 'invoicesInternalPortalLogin',
        name: (translateService) =>
          `${translateService.instant('labels.internalPortal')} (${translateService.instant('labels.login').toLowerCase()})`,
      },
      {
        key: 'invoicesInternalPortalPassword',
        name: (translateService) =>
          `${translateService.instant('labels.internalPortal')} (${translateService.instant('labels.password').toLowerCase()})`,
      },
      {
        key: 'invoicesTraditionalMail',
        name: 'labels.traditionalMail',
      },
      {
        key: 'invoicesIsOriginalDocumentRequired',
        name: 'labels.originalDocumentRequired',
      },
      {
        key: 'invoicesPrimaryCurrency',
        name: 'labels.currency',
      },
      {
        key: 'invoicesPrimaryLanguage',
        name: 'labels.language',
      },
    ],
    required: true,
  },
  {
    name: 'contractors.contractorForm.pointsOfInterest.heading',
    fields: [
      {
        key: 'pointsOfInterest',
        name: 'contractors.contractorForm.pointsOfInterest.heading',
      },
    ],
  },
  {
    name: 'labels.note',
    fields: [
      {
        key: 'note',
        name: 'labels.note',
      },
    ],
  },
] as const;
